export default "/media/logos/logo-sentia.svg"